import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { AccessTime as AccessTimeIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';

// Componente para a grid de últimas senhas
const UltimasSenhas = ({ senhas = [] }) => {
  // Preencher array com placeholders se não houver senhas suficientes
  const displaySenhas = [...senhas];
  while (displaySenhas.length < 4) {
    displaySenhas.push({ senha: '---', guiche: '--', preferencial: false, horario: '', status: null });
  }
  
  // Função auxiliar para obter o estilo baseado no status
  const getStatusStyle = (status) => {
    if (!status) return {};
    
    if (status === 'FINALIZADA') {
      return {
        bgcolor: '#f8f9fa', 
        border: '1px solid #e0e0e0',
        opacity: 1
      };
    }
    
    if (status === 'CANCELADA') {
      return {
        bgcolor: '#fff9f0', 
        border: '1px solid #ffe0b2',
        opacity: 1
      };
    }
    
    return {
      bgcolor: '#f8f9fa', 
      border: '1px solid #e9ecef',
    };
  };

  // Função para obter o rótulo do status
  const getStatusLabel = (status) => {
    if (!status) return null;
    
    if (status === 'Finalizada') {
      return {
        label: 'FINALIZADA',
        color: 'success'
      };
    }
    
    return {
      label: 'CHAMADA',
      color: 'info'
    };
  };
  
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center', fontSize: '1.8rem', color: 'text.primary' }}>
        Últimas Senhas Chamadas
      </Typography>
      
      <Box sx={{ 
        display: 'flex', 
        flexWrap: 'wrap',
        gap: 1.5
      }}>
        {displaySenhas.slice(0, 4).map((item, index) => {
          const statusInfo = getStatusLabel(item.status);
          
          return (
            <Box 
              key={index}
              sx={{ 
                width: 'calc(50% - 12px)',
                textAlign: 'center', 
                p: 1.5, 
                borderRadius: 3,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minHeight: '120px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                },
                ...getStatusStyle(item.status)
              }}
            >
              <Typography variant="h3" sx={{ 
                fontWeight: 'bold', 
                color: 'text.primary',
                fontSize: '2.8rem',
                mb: 0.8,
                lineHeight: 1
              }}>
                {item.senha}
              </Typography>
              
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, mb: 0.8 }}>
                {/* Tag de Preferencial/Comum */}
                <Box sx={{ 
                  display: 'inline-flex',
                  px: 1.5, 
                  py: 0.5, 
                  borderRadius: 2, 
                  bgcolor: item.preferencial ? '#f44336' : '#2196f3',
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  opacity: 1,
                  maxWidth: '100%',
                  boxShadow: item.preferencial ? '0 2px 8px rgba(244, 67, 54, 0.3)' : '0 2px 8px rgba(33, 150, 243, 0.3)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {item.preferencial ? 'PREFERENCIAL' : 'COMUM'}
                </Box>
                
                {/* Status da senha - Removido conforme solicitado */}
              </Box>
              
              <Typography variant="h6" sx={{ 
                color: 'text.primary',
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>
                Guichê {item.guiche}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default UltimasSenhas; 